import React from 'react';
import type { FC } from 'react';
import { Box } from '@wix/cli-ui-kit';
import { Trans } from '@wix/cli-i18n';
import { PreviewCommand } from '../../PreviewCommand/index.js';

interface CreatePreviewProps {
  baseUrl?: string;
  siteIdOverride?: string;
  onCreated: (tag: string) => void;
}

export const CreatePreview: FC<CreatePreviewProps> = (props) => {
  const { baseUrl, siteIdOverride, onCreated } = props;

  return (
    <Box flexDirection="column" gap={1}>
      <Trans i18nKey="release_command.check_preview_before_version_release" />
      <Box flexDirection="column">
        <PreviewCommand
          baseUrl={baseUrl}
          siteIdOverride={siteIdOverride}
          onPreviewCreated={({ armTag }) => onCreated(armTag)}
        />
      </Box>
    </Box>
  );
};
